import React from 'react'
import { Loader2 } from 'lucide-react'
import logo from '@/assets/logo.svg'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="flex items-center justify-center space-x-2">
          <img src={logo} alt="Ordore Logo" className="h-8 w-8" />
          <Loader2 className="h-8 w-8 text-restaurant-primary animate-spin" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            ordore Analytics
          </h2>
          <p className="text-muted-foreground">Loading your dashboard...</p>
        </div>
      </div>
    </div>
  )
}
